export const storage = {
  hash: '@vml/hash',
  showPushCount: '@vml/showPushCount',
  showPushInfoAlert: '@vml/showPushInfoAlert',
  enabledInitCount: '@vml/enabledInitCount',
};
